import React from 'react';
import { Video } from 'lucide-react';

interface VideoPlaceholderProps {
  style?: 'simple' | 'detailed';
  customMessage?: string;
}

/**
 * A standardized video placeholder component for lecture pages
 */
const VideoPlaceholder: React.FC<VideoPlaceholderProps> = ({ 
  style = 'detailed',
  customMessage
}) => {
  return (
    <div className="mb-8 mt-8 rounded-lg overflow-hidden border border-gray-200">
      <div className="aspect-w-16 aspect-h-9 bg-gray-100 flex items-center justify-center p-16">
        <div className="text-center">
          {style === 'detailed' ? (
            <>
              <Video className="h-12 w-12 mx-auto mb-4 text-gray-400" />
              <h3 className="text-xl font-medium text-gray-900 mb-2">Video Lecture Coming Soon</h3>
              <p className="text-gray-500 max-w-md mx-auto">
                {customMessage || 
                  'The full video lecture for this topic is currently being recorded and will be available soon. Check back for updates.'}
              </p>
            </>
          ) : (
            <>
              <Video className="h-10 w-10 mx-auto mb-3 text-gray-400" />
              <h3 className="text-lg font-medium text-gray-800">Video Coming Soon</h3>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default VideoPlaceholder;